import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const uploadBuktiBayar = createAsyncThunk("paymentUpload/upload", async (val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/payment-upload`, val);
    return response.data;
});

export const getBuktiBayarByUser = createAsyncThunk("paymentUpload/getByUser", async () => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/payment-upload/user`);
    return response.data;
});

// admin/operator : ambil bukti bayar milik user tertentu
export const getBuktiBayarByUserId = createAsyncThunk("paymentUpload/getByUserId", async (userId) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/payment-upload/user/${userId}`);
    return response.data;
});

// ambil bukti bayar berdasarkan transaksi (trxId)
export const getBuktiBayarByTrxId = createAsyncThunk("paymentUpload/getByTrxId", async (trxId) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/payment-upload/trx/${trxId}`);
    return response.data;
});

// hapus bukti bayar yang belum terverifikasi
export const deleteBuktiBayar = createAsyncThunk("paymentUpload/delete", async (id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.delete(`v1/payment-upload/${id}`);
    return response.data;
});

// admin/operator : validasi bukti bayar
export const validasiBuktiBayar = createAsyncThunk("paymentUpload/validasi", async ({ id, validasi = true }) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.put(`v1/payment-upload/${id}/validasi?validasi=${validasi}`);
    return response.data;
});

const initialState = {
    loading: false,
    saving: false,
    validating: false,
    deleting: false,
    error: null,
    uploadList: [],
    adminUploadList: [],
};

export const paymentUploadSlice = createSlice({
    name: 'paymentUpload',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBuktiBayarByUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(getBuktiBayarByUser.fulfilled, (state, action) => {
                state.loading = false;
                state.uploadList = action.payload;
            })
            .addCase(getBuktiBayarByUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message;
            })
            .addCase(uploadBuktiBayar.pending, (state) => {
                state.saving = true;
            })
            .addCase(uploadBuktiBayar.fulfilled, (state) => {
                state.saving = false;
            })
            .addCase(uploadBuktiBayar.rejected, (state, action) => {
                state.saving = false;
                state.error = action.error?.message;
            })
            .addCase(getBuktiBayarByUserId.pending, (state) => {
                state.loading = true;
            })
            .addCase(getBuktiBayarByUserId.fulfilled, (state, action) => {
                state.loading = false;
                state.adminUploadList = action.payload;
            })
            .addCase(getBuktiBayarByUserId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message;
            })
            .addCase(getBuktiBayarByTrxId.pending, (state) => {
                state.loading = true;
            })
            .addCase(getBuktiBayarByTrxId.fulfilled, (state, action) => {
                state.loading = false;
                state.adminUploadList = action.payload;
            })
            .addCase(getBuktiBayarByTrxId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message;
            })
            .addCase(validasiBuktiBayar.pending, (state) => {
                state.validating = true;
            })
            .addCase(validasiBuktiBayar.fulfilled, (state) => {
                state.validating = false;
            })
            .addCase(validasiBuktiBayar.rejected, (state, action) => {
                state.validating = false;
                state.error = action.error?.message;
            })
            .addCase(deleteBuktiBayar.pending, (state) => {
                state.deleting = true;
            })
            .addCase(deleteBuktiBayar.fulfilled, (state) => {
                state.deleting = false;
            })
            .addCase(deleteBuktiBayar.rejected, (state, action) => {
                state.deleting = false;
                state.error = action.error?.message;
            });
    },
});

export const paymentUploadSelector = (state) => state.paymentUpload;

export default paymentUploadSlice.reducer;
